import * as d3 from 'd3';
import { drawColonialGrills } from './drawColonialGrills';
import { drawPrairieGrills } from './drawPrairieGrills';
import { drawShortFractionalGrills } from './drawShortFractionalGrills';
import { drawTallFractionalGrills } from './drawTallFractionalGrills';
import { drawQueenAnneGrills } from './drawQueenAnneGrills';
import { drawVictorianGrills } from './drawVictorianGrills';
import { drawDiamondGrills } from './drawDiamondGrills';
import { drawCottageGrills } from './drawCottageGrills';

export function drawGrills(svg, indexWindow = 1, x, y, width, height, frameWidth = 10, doorData, top = false,
                           shape = 'Rectangle',
                           shapeOrientation = 'left',
                           y1 = 0,
                           y2 = 0,
                           innerPoints = null) {

  let ins = '';
  if (top) { ins = 'Top'; }
  
  const grillType = `grillType${ins}${indexWindow}`;
  const grillTypeValue = doorData?.grills?.[grillType].value || "Unknown";

  if (grillTypeValue === "None"){
     return;
  }

  const grillsPattern = `grillsPattern${ins}${indexWindow}`;
  const grillsPatternValue = doorData?.grills?.[grillsPattern]?.value || "Unknown";

  const grillsSize = `grillsSize${ins}${indexWindow}`;
  const grillsSizeValue = doorData?.grills?.[grillsSize];

  const hashSize = {
      '5/16"': 0.8,   // 0.3125
      '5/8"': 1.5,    // 0.625
      '3/4"': 2,      // 0.75
      '7/8"': 2.5,    // 0.875
      '1"': 3,        // 1.0
      '1 1/4"': 3.5,  // 1.25
      '2"': 4         // 2.0
    };
    
  const glassDividers = `glassDividers${ins}${indexWindow}`;
  const glassDividersValue = doorData?.grills?.[glassDividers];
 
    const glassDividersVertical = `glassDividersVertical${ins}${indexWindow}`;
    const glassDividersHorizontal = `glassDividersHorizontal${ins}${indexWindow}`;
    const glassDividersVerticalValue = doorData?.grills?.[glassDividersVertical] || 0;
    const glassDividersHorizontalValue = doorData?.grills?.[glassDividersHorizontal] || 0;

    const grillsColor = doorData.flipped ? doorData?.grills?.exteriorFinish.value || 'white' :
                                           doorData?.grills?.interiorFinish.value || 'white' ;

    if (grillsPatternValue === 'Diamond') {
      drawDiamondGrills(svg,
        x+1, y+1, width-1, height-2, frameWidth,
        parseInt(glassDividersHorizontalValue),
        parseInt(glassDividersVerticalValue),
        grillsColor,  'black', 0.2, hashSize[grillsSizeValue], shape, shapeOrientation, y1, y2, innerPoints);
    }

    if (grillsPatternValue === 'Colonial') {
      drawColonialGrills(svg,
        x, y, width, height, frameWidth,
        parseInt(glassDividersHorizontalValue),
        parseInt(glassDividersVerticalValue),
        grillsColor,  'black', 0.2, hashSize[grillsSizeValue], shape, shapeOrientation, y1, y2, innerPoints);
    }

    if (grillsPatternValue === 'Cottage') {
      const cottageOptionKey = `cottageOptions${ins}${indexWindow}`;
      const cottageOptionValue = doorData?.grills?.[cottageOptionKey]?.value || '1/4';
      drawCottageGrills(svg,
        x, y, width, height, frameWidth,
        parseInt(glassDividersHorizontalValue),
        parseInt(glassDividersVerticalValue),
        grillsColor, 'black', 0.2, hashSize[grillsSizeValue], shape, shapeOrientation, y1, y2, innerPoints,
        cottageOptionValue);
    }

    if (grillsPatternValue === 'Prairie') {
      const prairieDividersKey = `prairieDividers${ins}${indexWindow}`;
      const prairieDividersValue = doorData?.grills?.[prairieDividersKey]?.value || 'standard';
      drawPrairieGrills(svg,
        x, y, width, height, frameWidth,
        0.15, grillsColor, 'black', 0.2, hashSize[grillsSizeValue], prairieDividersValue);
    }
    
    if (grillsPatternValue === 'Short Fractional') {
      drawShortFractionalGrills(svg,
        x, y, width, height, frameWidth,
        grillsColor, 'black', 0.2, true, true, hashSize[grillsSizeValue]);
    }

    if (grillsPatternValue === 'Tall Fractional') {
      drawTallFractionalGrills(svg,
        x, y, width, height, frameWidth,
        grillsColor, 'black', 0.2,  hashSize[grillsSizeValue], 0.6);
    }   

    if (grillsPatternValue === 'Queen Anne') {
      drawQueenAnneGrills(svg,
        x, y, width, height, frameWidth,
        parseInt(glassDividersVerticalValue), parseInt(glassDividersHorizontalValue),              // ver/hor 
        grillsColor, 'black', 0.2,          // fillColor          // strokeColor
          hashSize[grillsSizeValue],                  // grillThickness
          0.33
        );  
    }

    if (grillsPatternValue === 'Victorian') {
      drawVictorianGrills(svg,
        x, y, width, height, frameWidth,
        3,3,//parseInt(glassDividersVerticalValue), parseInt(glassDividersHorizontalValue),              // ver/hor 
        grillsColor, 'black', 0.2,          // fillColor          // strokeColor
          hashSize[grillsSizeValue]                  // grillThickness
        );  
    }
  
  }//drawGrills
  

  